import { render, staticRenderFns } from "./editTaxRate.vue?vue&type=template&id=296b560e&"
import script from "./editTaxRate.vue?vue&type=script&lang=js&"
export * from "./editTaxRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports